import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import {
  CheckboxesComponent,
  SwitchComponent,
} from '../../../../../Components';
import DragDropPicker from '../../Utilities/DragDropPicker/DragDropPicker';
import { getPublicDownloadableLink } from '../../../../../Helper';
import { UnitFinancialFees } from '../../Enums/UnitFinancialFees';
import { formatNumberWithCommas } from '../../Utilities/utils';

let isNumbersFormatted = false;
const UnitsDetailsForm = ({
  localFormChangeHandler,
  localFormSelection,
  isForLease,
}) => {
  const parentTranslationPath = 'SmartProposal';
  const isFirstLanding = useRef(true);

  const initializeUnitImages = () => {
    const selectedImageId = isFirstLanding.current
      ? localFormSelection?.data?.unitPublishedImages[0]?.fileId
      : localFormSelection?.unitImage?.id;
    const publishedImages = [
      ...(localFormSelection?.data?.unitPublishedImages || []),
    ];

    publishedImages.forEach((item) => {
      if (item.fileId === selectedImageId) {
        item.isChecked = true;
      } else {
        item.isChecked = false;
      }
    });
    return publishedImages;
  };

  const unitPublishedImages = useMemo(
    () => initializeUnitImages(),
    [localFormSelection]
  );
  const unitImageSelectHandler = useCallback(
    (result) => {
      const defaultUnitImage = {
        url: 'https://replica.psi-crm.com/ProposalIcons/defaultCover.jpg',
        id: null,
      };

      const pickedImageId = Array.isArray(result) && result?.[0]?.fileId;
      const unitImageURL = pickedImageId
        ? getPublicDownloadableLink(pickedImageId)
        : null;

      const unitImage = unitImageURL
        ? {
            url: unitImageURL,
            id: pickedImageId,
          }
        : defaultUnitImage;

      localFormChangeHandler('unitImage', unitImage);
    },
    [localFormChangeHandler]
  );

  const financialFeesChangeHandler = (checkedItem) => {
    const checkedItemKey = checkedItem?.key;
    const checkedItemValue =
      localFormSelection?.financialFees[checkedItemKey] || false;

    const localFinancialFees = {
      ...localFormSelection?.financialFees,
      [checkedItemKey]: !checkedItemValue,
    };

    localFormChangeHandler('financialFees', localFinancialFees);
  };

  const returnCheckedItemValue = (checkedItem) => {
    const checkedItemKey = checkedItem?.key;
    const checkedItemValue =
      localFormSelection?.financialFees[checkedItemKey] || false;
    return checkedItemValue;
  };

  useEffect(() => {
    if (localFormSelection?.data?.unitsDetailsData && !isNumbersFormatted) {
      const {
        agencyFees,
        chillerCharges,
        sellingPrice,
        serviceCharge,
        transferFees,
        nocFeeBuyer,
        rentalExpiryDate,
        currentRentAmount,
        leased,
        numberOfPayment,
        paymentModeDetails,
        commissionFees,
        securityDeposit,
      } = localFormSelection.data.unitsDetailsData;
      if (+agencyFees && !isForLease) {
        localFormSelection.data.unitsDetailsData.agencyFees =
          formatNumberWithCommas(agencyFees);
      } else {
        localFormSelection.financialFees.showAgencyFees = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showAgencyFees'
        ).isDisabled = true;
      }
      if (+chillerCharges) {
        localFormSelection.data.unitsDetailsData.chillerCharges =
          formatNumberWithCommas(chillerCharges);
      } else {
        localFormSelection.financialFees.showChillerCharges = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showChillerCharges'
        ).isDisabled = true;
      }
      if (+sellingPrice && !isForLease) {
        localFormSelection.data.unitsDetailsData.sellingPrice =
          formatNumberWithCommas(sellingPrice);
      } else {
        localFormSelection.financialFees.showSellingPrice = false;
      }
      if (+serviceCharge && !isForLease) {
        localFormSelection.data.unitsDetailsData.serviceCharge =
          formatNumberWithCommas(serviceCharge);
      } else {
        localFormSelection.financialFees.showServiceCharge = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showServiceCharge'
        ).isDisabled = true;
      }
      if (+transferFees && !isForLease) {
        localFormSelection.data.unitsDetailsData.transferFees =
          formatNumberWithCommas(transferFees);
      } else {
        localFormSelection.financialFees.showTransferFees = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showTransferFees'
        ).isDisabled = true;
      }
      if (+nocFeeBuyer && !isForLease) {
        localFormSelection.data.unitsDetailsData.nocFeeBuyer =
          formatNumberWithCommas(nocFeeBuyer);
      } else {
        localFormSelection.financialFees.showNOCFeeBuyer = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showNOCFeeBuyer'
        ).isDisabled = true;
      }
      if (!rentalExpiryDate) {
        localFormSelection.financialFees.showRentalExpiryDate = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showRentalExpiryDate'
        ).isDisabled = true;
      }
      if (!currentRentAmount) {
        localFormSelection.financialFees.showCurrentRentAmount = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showCurrentRentAmount'
        ).isDisabled = true;
      }
      if (!leased) {
        localFormSelection.financialFees.showLeased = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showLeased'
        ).isDisabled = true;
      }
      if (!numberOfPayment || !isForLease) {
        localFormSelection.financialFees.showNumberOfPayment = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showNumberOfPayment'
        ).isDisabled = true;
      }
      if (!paymentModeDetails || !isForLease) {
        localFormSelection.financialFees.showPaymentModeDetails = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showPaymentModeDetails'
        ).isDisabled = true;
      }
      if (!commissionFees || !isForLease) {
        localFormSelection.financialFees.showCommissionFees = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showCommissionFees'
        ).isDisabled = true;
      }
      if (!+securityDeposit || !isForLease) {
        localFormSelection.financialFees.showSecurityDeposit = false;
        UnitFinancialFees.find(
          (item) => item.key === 'showSecurityDeposit'
        ).isDisabled = true;
      }
      const checkAllValues = [
        agencyFees,
        chillerCharges,
        serviceCharge,
        transferFees,
        nocFeeBuyer,
        rentalExpiryDate,
        currentRentAmount,
        !!leased,
        numberOfPayment,
        paymentModeDetails,
        commissionFees,
      ].some((item) => {
        if (typeof item === 'string') {
          item = +item.replace('.', '');
          return isNaN(item) || item === 0;
        }
        return !!item;
      });
      localFormSelection.data.unitsDetailsData.isEmpty = !checkAllValues;
      localFormSelection.showFinancialFees = checkAllValues;
      localFormChangeHandler({
        id: 'edit',
        value: { ...localFormSelection },
      });
      unitImageSelectHandler(
        localFormSelection?.data?.unitPublishedImages.filter(
          (item) => item.isChecked
        )
      );
      isFirstLanding.current = false;
      isNumbersFormatted = true;
    }
  }, [
    localFormSelection.data?.unitsDetailsData,
    localFormSelection?.data?.unitPublishedImages,
  ]);
  useEffect(() => {
    return () => {
      UnitFinancialFees.forEach((item) => {
        delete item.isDisabled;
      });
    };
  }, []);

  return (
    <>
      <div className='ProposalForm__field_box'>
        <div className='ProposalForm__field_label'>
          <p>Unit image</p>
        </div>
        <div>
          <DragDropPicker
            onChange={unitImageSelectHandler}
            itemsList={unitPublishedImages}
            maxChecked={1}
          />
        </div>
      </div>
      <div className='ProposalForm__field_box'>
        <div className='ProposalForm__field_label'>
          <p>Financial fees</p>
          {/* <p>{t(`${translationPath}-`)}</p> */}
        </div>
        <div>
          <SwitchComponent
            idRef='showFinancialFeesRef'
            wrapperClasses='mb-3'
            themeClass='thick-theme'
            isChecked={localFormSelection?.showFinancialFees}
            labelValue={`${
              localFormSelection?.showFinancialFees ? 'show' : 'hide'
            }`}
            parentTranslationPath={parentTranslationPath}
            translationPath={''}
            onChangeHandler={(_, isChecked) =>
              localFormChangeHandler('showFinancialFees', isChecked)
            }
            isDisabled={localFormSelection.data?.unitsDetailsData.isEmpty}
          />
          {!localFormSelection.data?.unitsDetailsData.isEmpty && (
            <CheckboxesComponent
              idRef='isPublishUnitSaleRef'
              themeClass='theme-propx'
              data={UnitFinancialFees.filter((item) => {
                if (isForLease) {
                  return item.isForLease || !item.isForSale;
                } else if (isForLease === false) {
                  return item.isForSale || !item.isForLease;
                }
              })}
              isDisabledInput={'isDisabled'}
              isRow
              onSelectedCheckboxChanged={financialFeesChangeHandler}
              parentTranslationPath={parentTranslationPath}
              translationPathForData={''}
              labelInput='label'
              checked={returnCheckedItemValue}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default UnitsDetailsForm;
